(() => {
  if (customElements.get('cosy-cart-hearts')) return;
  let pending;
  let checkedAt = 0;
  const policy = () => {
    if (!pending || Date.now() - checkedAt > 20000) {
      checkedAt = Date.now();
      pending = fetch('/apps/cosy-herzen?resource=earning-preview', {
        credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'},
        signal: AbortSignal.timeout(8000)
      }).then(response => {
        if (!response.ok) throw new Error('Unavailable');
        return response.json();
      }).catch(() => null);
    }
    return pending;
  };
  // Match the order ledger: round base hearts, then add the scoped bonus once.
  function calculate(lines, campaign, now = Date.now()) {
    const total = lines.reduce((sum, line) => sum + line.cents, 0);
    const base = Math.floor(total / 100);
    if (!campaign || Date.parse(campaign.endAt) <= now) return base;
    const scale = Math.round(Number(campaign.factor) * 10);
    if (!Number.isFinite(scale) || scale < 10 || scale > 30) throw new Error('Invalid campaign');
    const collections = campaign.collectionIds || [];
    if (!collections.length) return Math.floor(base * scale / 10);
    const matched = lines.reduce((sum, line) => sum + (line.collections.some(id => collections.includes(id)) ? line.cents : 0), 0);
    return base + Math.floor(Math.floor(matched / 100) * (scale - 10) / 10);
  }
  function bonusLabel(lines, campaign, hearts, base, partialLabel, now = Date.now()) {
    if (!campaign || !Number.isFinite(Date.parse(campaign.endAt)) || Date.parse(campaign.endAt) <= now || hearts <= base) return '';
    const collections = campaign.collectionIds || [];
    const full = !collections.length || lines.every(line => line.cents === 0 || line.collections.some(id => collections.includes(id)));
    return full ? '(×' + String(Number(campaign.factor)).replace('.', ',') + ')' : '(' + partialLabel + ')';
  }
  customElements.define('cosy-cart-hearts', class extends HTMLElement {
    connectedCallback() {
      this.refresh();
      this.timer = setInterval(() => { if (!document.hidden) this.refresh(); }, 30000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    async refresh() {
      const result = await policy();
      if (!this.isConnected) return;
      if (!result || !Object.prototype.hasOwnProperty.call(result, 'campaign')) {
        this.style.display = 'none';
        return;
      }
      const lines = Array.from(this.querySelectorAll('[data-cosy-cart-line]'), node => ({
        cents: Number(node.dataset.cents), collections: node.dataset.collections.split(',').filter(Boolean)
      }));
      let hearts;
      try {
        if (!lines.length || lines.some(line => !Number.isSafeInteger(line.cents) || line.cents < 0)) throw new Error('Invalid cart');
        hearts = calculate(lines, result.campaign);
      } catch (_) { this.style.display = 'none'; return; }
      const base = Math.floor(lines.reduce((sum, line) => sum + line.cents, 0) / 100);
      this.querySelector('[data-heart-base]').textContent = String(base);
      this.querySelector('[data-heart-bonus]').textContent = '+' + String(hearts - base);
      this.querySelector('[data-heart-total]').textContent = String(hearts);
      this.querySelector('[data-heart-bonus-row]').hidden = hearts === base;
      const state = this.dataset.signedIn !== 'true' || result.eligible === false ? 'guest' : result.eligible === true ? 'member' : 'unknown';
      const title = this.querySelector('[data-cosy-cart-title]');
      const parts = this.dataset[state + 'Title'].split('COSYCOUNT');
      const count = document.createElement('strong');
      count.className = 'cosy-cart-hearts__count';
      count.textContent = String(hearts);
      title.replaceChildren(document.createTextNode(parts[0]), count, document.createTextNode(parts.slice(1).join(String(hearts))));
      const bonus = this.dataset.compact === 'true' ? bonusLabel(lines, result.campaign, hearts, base, this.dataset.bonusIncluded) : '';
      this.classList.toggle('cosy-cart-hearts--bonus', Boolean(bonus));
      if (bonus) {
        const badge = document.createElement('span');
        badge.className = 'cosy-cart-hearts__campaign';
        badge.textContent = ' ' + bonus;
        count.after(badge);
      }
      const link = this.querySelector('[data-cosy-cart-link]');
      const member = state !== 'guest';
      link.textContent = (member ? this.dataset.memberLink : this.dataset.guestLink) + ' →';
      link.href = member ? this.dataset.accountUrl : this.dataset.clubUrl;
      this.style.removeProperty('display');
    }
  });
})();
